/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=34ef528e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ef528e"]])

export default __exports__